export default __webpack_public_path__ + "static/media/badge-1.59cf7072.png";